import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import TableCell from "../Components/TableCell";

import { useTheme } from "@mui/material/styles";

import { getSignalData } from "../Service/data";

const SignalPage = () => {
  const [data, setData] = useState([]);
  const [noData, setNoData] = useState(true);
  const [loading, setLoading] = useState(true);

  const theme = useTheme();

  useEffect(() => {
    getSignalData()
      .then((data) => {
        setData(data);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (data !== undefined && data !== null && data.length > 0) {
      console.log(data);
      setLoading(false);
      setNoData(false);
    }
  }, [data]);

  const columns = useMemo(
    //column definitions...
    () => [
      {
        id: "info", //id used to define `group` column
        header: "Info",
        columns: [
          {
            accessorKey: "symbol", //accessorFn used to join multiple data into a single cell
            id: "symbol", //id is still required when using accessorFn instead of accessorKey
            header: "Ticker",
            size: 250
          },
          {
            accessorKey: "type", //accessorKey used to define `data` column. `id` gets set to accessorKey automatically
            header: "Signal",
            size: 300,
          },
        ],
      },
      {
        id: "general",
        header: "Data",
        columns: [
          {
            accessorFn: (row) => row?.info?.['1d_change'],
            header: "1d_change",
            filterFn: 'lessThan',
            size: 200,
          },
          {
            accessorFn: (row) => row?.info?.['5d_change'],
            header: "5d_change",
            filterFn: 'lessThan',
            size: 200,
          },
          {
            accessorFn: (row) => row?.info?.['1m_change'],
            header: "1m_change",
            filterFn: 'lessThan',
            size: 200,
          },
          {
            accessorFn: (row) => row?.info?.['1d_change'],
            header: "1d_change",
            filterFn: 'lessThan',
            size: 200,
          },
        ],
      }
    ],
    []
    //end
  );
  const table = useMaterialReactTable({
    columns,
    data,
    // enableFilters: false,
    enableFullScreenToggle: false,
    enableStickyHeader: true,
    enableColumnPinning: true,
    initialState: { 
      density: 'compact',
      columnPinning: { left: ['ticker', 'Signal'] },
    }
  });

  return (
    <div style={{ width: "100%", minWidth: '100vw', minHeight: '100vh', background: `${theme.palette.background.default}` }}>
      {loading && <CircularProgress />}
      {noData && <Typography>No data was received</Typography>}
      {data !== null &&
          data !== undefined && <MaterialReactTable table={table}/>}
    </div>
  );
};

export default SignalPage;
